import { Box, Card, Typography } from '@mui/material'
import './timetableCard.scss'
import { capitalizeAllLetter, capitalizeFirstLetter } from '../../utility/genricFunction'
import deleteIcon from '../../assets/icons/delete.svg'

function TimetableCard({ timetableData, onClick, onDelete }) {
  const arr = timetableData

  const CardBox = ({ data }) => {
    return (
      <Box className='timetable-card-box-topic flex flex-column'>
        <div className='timetable-card-box-detail flex'>
          <Typography className='timetable-card-box-topic-title'>Branch:</Typography>
          <Typography className='timetable-card-box-topic-description'>
            {capitalizeFirstLetter(data.branch.branchName)}
          </Typography>
        </div>
        <div className='flex'>
          <Typography className='timetable-card-box-topic-title'>Batch:</Typography>
          <Typography className='timetable-card-box-topic-description'>{data.batch.batchNo}</Typography>
        </div>
        <div className='flex'>
          <Typography className='timetable-card-box-topic-title'>Classroom:</Typography>
          <Typography className='timetable-card-box-topic-description'>
            {capitalizeFirstLetter(data.branch_classroom.className)}
          </Typography>
        </div>
        <div className='flex'>
          <Typography className='timetable-card-box-topic-title'>Faculty:</Typography>
          <Typography className='timetable-card-box-topic-description'>
            {capitalizeFirstLetter(data.faculty.user.facultyName)}
          </Typography>
        </div>
        <div className='flex'>
          <Typography className='timetable-card-box-topic-title'>Course:</Typography>
          <Typography className='timetable-card-box-topic-description'>
            {capitalizeFirstLetter(data.course.courseName)}
          </Typography>
        </div>
        <div className='flex'>
          <Typography className='timetable-card-box-topic-title'>Module:</Typography>
          <Typography className='timetable-card-box-topic-description'>
            {capitalizeFirstLetter(data.courseModule.courseModuleName)}
          </Typography>
        </div>
      </Box>
    )
  }
  return (
    <>
      {arr ? (
        timetableData?.map((item, index) => (
          <Box className='flex justify-center' key={index}>
          <img src={deleteIcon} className='delete-icon' onClick={() => onDelete(item)}/>
            <Card className='timetable-card' variant='outlined' onClick={() => onClick(item)}>
              <Box className='timetable-card-item'>
                <Box
                  className={`timetable-card-title ${item.type === 'online_exam' ? 'timetable-card-title-green' : ''} ${item.type === 'offline_exam' ? 'timetable-card-title-grey' : ''} ${item.type === 'lecture' ? 'timetable-card-title-red' : ''}`}
                >
                  {capitalizeAllLetter(item.type)}
                </Box>
                <Typography className='timetable-card-time'>{`${item.startTime} - ${item.endTime}`}</Typography>
                <Box className='timetable-card-box'>
                  <CardBox data={item} />
                </Box>
              </Box>
            </Card>
          </Box>
        ))
      ) : (
        <Box className='timetable-box'></Box>
      )}
    </>
  )
}

export default TimetableCard
